import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sellers-dashboard-navs',
  templateUrl: './sellers-dashboard-navs.component.html',
  styleUrls: ['./sellers-dashboard-navs.component.css']
})
export class SellersDashboardNavsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
